import customResultTexture from '@assets/ladybug_1.png'
import { useConfigurationStore, useCustomResultStore } from '@stores'
import { usePerformanceMetrics } from '@hooks'
import React, { useEffect, useState } from 'react'

import { withAutoBlur } from '../../utils/misc'
import {
    CustomResultOpenButtonClickMessage,
    CustomResultToggleVisibilityMessage,
    GameUIMessageScope,
    GameUIMessageType,
} from 'game-ui-types'
import { cn } from '@amusnet/react-ui'

const CustomResult: React.FC = () => {
    const updateIsOpened = useCustomResultStore((state) => state.updateIsOpened)
    const isOpened = useCustomResultStore((state) => state.isOpened)
    const [isVisible, setIsVisible] = useState(true)
    const styles = useConfigurationStore((state) => state.getComponentConfig('CustomResult').styles)
    const position = useConfigurationStore((state) => state.getComponentConfig('CustomResult').position)

    const { drawCalls, fps } = usePerformanceMetrics()

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.shiftKey && (e.key === 'D' || e.key === 'd')) {
                e.preventDefault()
                setIsVisible((v) => !v)

                const toggleVisibilityMessage: CustomResultToggleVisibilityMessage = {
                    type: GameUIMessageType.CUSTOM_RESULT_TOGGLE_VISIBILITY,
                    scope: GameUIMessageScope.CUSTOM_RESULT,
                    value: !isVisible,
                }

                window.uiBus.postMessage(toggleVisibilityMessage)
            }
        }

        window.addEventListener('keydown', onKey)

        return () => window.removeEventListener('keydown', onKey)
    }, [])

    const handleClick = withAutoBlur(() => {
        updateIsOpened(!isOpened)

        const openButtonClickedMessage: CustomResultOpenButtonClickMessage = {
            type: GameUIMessageType.CUSTOM_RESULT_OPEN_BUTTON_CLICK,
            scope: GameUIMessageScope.CUSTOM_RESULT,
        }

        window.uiBus.postMessage(openButtonClickedMessage)
    })

    return (
        <div className={cn(styles, isVisible ? 'block' : 'hidden')} style={position}>
            <span
                id="custom-result-fps"
                className={cn(
                    isVisible ? 'block' : 'hidden',
                    'text-[36px] font-medium text-white antialiased [-webkit-text-stroke:3px_#000] [paint-order:stroke_fill]'
                )}
            >
                {fps.toFixed(2)}
            </span>
            <button onClick={handleClick}>
                <img id="custom-result-button" src={customResultTexture} alt="custom result" />
            </button>
            <span
                id="custom-result-draw-calls"
                className={cn(
                    isVisible ? 'block' : 'hidden',
                    'text-[36px] font-medium text-white antialiased [-webkit-text-stroke:3px_#000] [paint-order:stroke_fill]'
                )}
            >
                {drawCalls}
            </span>
        </div>
    )
}

export default CustomResult
